// src/puzzles/puzzles.js

export const PUZZLES = [
    {
        id: "scotch",
        title: "Удар в центре",
        description:
            "Белые начинают игру в центре: d2-d4, после взятия пешки конь отыгрывает её.",
        puzzle: {
            fen: "r1bqkbnr/pppp1ppp/2n5/4p3/4P3/5N2/PPPP1PPP/RNBQKB1R w KQkq - 2 3",
            moves: ["d2d4", "e5d4", "f3d4"],
            makeFirstMove: false,
        },
    },
    {
        id: "back-rank-mate",
        title: "Мат по последней горизонтали",
        description:
            "Чёрный король заперт собственными пешками. Найди мат в один ход.",
        puzzle: {
            fen: "6k1/5ppp/8/8/8/8/8/4R2K w - - 0 1",
            moves: ["e1e8"],
            makeFirstMove: false,
        },
    },
    {
        id: "scholars-mate",
        title: "Детский мат",
        description:
            "Классическая атака ферзя и слочника на пункт f7.",
        puzzle: {
            fen: "r1bqkbnr/pppp1ppp/2n5/4p3/2B1P3/5Q2/PPPP1PPP/RNB1K1NR w KQkq - 2 3",
            moves: ["f3f7"],
            makeFirstMove: false,
        },
    },
    {
        id: "ladder-mate",
        title: "Лестничный мат",
        description:
            "Одна ладья уже режет седьмую горизонталь. Второй нужно добить по восьмой.",
        puzzle: {
            fen: "7k/R7/8/8/8/8/8/1R4K1 w - - 0 1",
            moves: ["b1b8"],
            makeFirstMove: false,
        },
    },
    {
        id: "knight-fork",
        title: "Вилка конём",
        description:
            "Найди ход конём, после которого одновременно бьются король и ладья.",
        puzzle: {
            fen: "r3k2r/5ppp/8/1N6/8/8/1PP5/7K w - - 0 1",
            moves: ["b5c7", "e8f8", "c7a8"],
            makeFirstMove: false,
        },
    },
    {
        id: "smothered-mate",
        title: "Спёртый мат",
        description:
            "Чёрный король зажат собственными фигурами. Конь ставит точку.",
        puzzle: {
            fen: "6rk/6pp/8/4N3/8/8/8/6K1 w - - 0 1",
            moves: ["e5f7"],
            makeFirstMove: false,
        },
    },
    {
        id: "anastasia-mate",
        title: "Мат Анастасии",
        description:
            "Красивая комбинация с жертвой ферзя и матом по вертикали h.",
        puzzle: {
            fen: "5rk1/5ppp/8/4N3/8/3Q4/8/6KR w - - 0 1",
            moves: ["e5e7", "g8h8", "d3h7", "h8h7"],
            makeFirstMove: false,
        },
    },
    {
        id: "skewer-queen",
        title: "Шампур",
        description:
            "Король и ферзь чёрных стоят на одной вертикали. Шах — и ферзь теряется.",
        puzzle: {
            fen: "4q3/8/8/4k3/8/8/8/R6K w - - 0 1",
            moves: ["a1e1", "e5d6", "e1e8"],
            makeFirstMove: false,
        },
    },
    {
        id: "epaulette-mate",
        title: "Мат эполетом",
        description:
            "Ладьи стоят рядом с королём и сами мешают ему убежать.",
        puzzle: {
            fen: "3rkr2/8/8/8/8/1Q6/8/6K1 w - - 0 1",
            moves: ["b3e6"],
            makeFirstMove: false,
        },
    },
    {
        id: "AHGPPS44",
        title: "Ладья забирает ферзя",
        description:
            "Ладья забирает ферзя с дальнейшем преимуществом",
        puzzle: {
            fen: "5rk1/p4p2/5qpR/1R1Q4/3PK3/4P1P1/P1r2PP1/8 b - - 1 1",
            moves: ["f8e8"],
            makeFirstMove: false,
        },
    },
    {
        id: "1UWoY",
        title: "Лучший ход",
        description:
            "Ладья бьет ладью с матом",
        puzzle: {
            fen: "3r2k1/1n3pp1/1p2Q3/1N1pP1P1/3P1n2/4N2r/5P2/1R3K1R b - - 0 1",
            moves: ["h3h1"],
            makeFirstMove: false,
        },
    },
];
